function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.75,
  d: "M27.8137 24.3139L27.9208 24.3468C28.3679 24.484 30.7178 25.2225 33.1519 26.1852L34.7846 22.984L36.0575 23.6326L36.706 22.3598L34.1604 21.0627L40 9.60785L37.4559 8.31079L31.6163 19.7657L29.0707 18.4687L28.4222 19.7414L29.6965 20.3899L27.7037 24.2968C27.7052 24.2968 27.7052 24.2968 27.7066 24.2968L27.8137 24.3139Z",
  fill: "#8C9EFF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.4995 25.7125C27.4995 25.7125 22.4984 24.9982 24.9997 22.4984C25.3268 22.1713 25.5968 21.7342 25.8425 21.2571C26.6639 20.1 27.2481 18.6901 27.6638 17.1759C28.0709 16.6574 28.4723 15.7689 28.7351 14.7118C29.1651 12.9962 29.0665 11.492 28.5266 11.2463C28.5537 10.655 28.5695 10.0707 28.5695 9.50791C28.5695 3.29406 24.7312 0 19.9986 0C15.2661 0 11.4278 3.29549 11.4278 9.50791C11.4278 10.0707 11.4449 10.655 11.4706 11.2463C10.9307 11.4892 10.8321 12.9934 11.2621 14.7118C11.5263 15.7689 11.9277 16.6574 12.3348 17.1788C12.7505 18.6915 13.3348 20.1014 14.1548 21.2556C14.4004 21.7342 14.6704 22.1727 14.999 22.4984C17.4988 24.9982 12.4992 25.7125 12.4992 25.7125C12.4992 25.7125 4.68685 28.1237 2.49987 29.9979C0.312879 31.872 0 39.9972 0 39.9972H19.9986H39.9972C39.9972 39.9972 39.6829 31.872 37.4974 29.9979C35.3118 28.1237 27.4995 25.7125 27.4995 25.7125ZM13.2763 13.8662C12.7177 13.3076 12.7177 12.4048 13.2763 11.8463C13.8348 11.2878 14.7375 11.2878 15.296 11.8463C15.3003 11.8463 16.5488 12.8562 20 12.8562C23.4912 12.8562 24.7283 11.8206 24.7397 11.812C25.3211 11.3078 26.2139 11.3378 26.7396 11.902C27.2624 12.4648 27.2666 13.3219 26.7224 13.8662C26.4153 14.1747 24.6426 15.7132 20 15.7132C15.3575 15.7132 13.5848 14.1747 13.2763 13.8662Z",
  fill: "#8C9EFF"
});

var SvgTradeOfTheDayIcon = function SvgTradeOfTheDayIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTradeOfTheDayIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trade-of-the-day-icon.71673f6c.svg";
export { ForwardRef as ReactComponent };